import React, { useEffect, useState } from 'react';
import { localize } from 'src/l10n';
import { SocialPostSharePost } from 'src/social-feed/components/SocialPostShare/SocialPostShare';
import { getSharePreviewAsync } from 'src/share';

interface IProps {
    uberId: number;
}

const ChatSharePreview = (props: IProps) => {
    const [share, setShare] = useState<any>(null);
    const [hasError, setHasError] = useState<boolean>(false);

    useEffect(() => {
        let cancelled = false;

        setShare(null);
        setHasError(false);

        getSharePreviewAsync(props.uberId)
            .then((data) => {
                if (!cancelled) {
                    setShare(data);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setHasError(true);
                }
            });

        return () => { cancelled = true; };
    }, [props.uberId]);

    if (hasError) {
        return <div className="chat-share-preview-error">{localize("TeknisktFel")}</div>;
    }

    if (!share) {
        return null;
    }

    return <SocialPostSharePost post={{ Share: share } as any} />;
};

export default ChatSharePreview;
